import Moment from 'moment';
import { keyLanguage } from "fides-angularjs-components/src/fts-services/fts-user-service";
import { accounts } from '../../services/arsweb/RoutingPaths';
import { CommonViewController, CONSOLIDATION_CURRENCY_PARAMS } from '../../controller/CommonViewController';
import { ReportService } from '../../services/export/ReportService';
import { EXPORT_TYPE } from "../export/ExportModalController";
import { REPORT_TYPE } from "../report/ReportModalController";
import { ConfirmationModalBean } from "../modal/ConfirmationModalBean";
import { ReactExportController } from "./export/reactExportComponent";
import { FilterUtil } from "../utils/filtering/FilterUtil";
import { DATEFORMAT_KEY, CALENDAR_START_DAY_KEY } from "../../common/filters/fsDateUtils";
import { NUMBERFORMAT_KEY } from "../../common/filters/fsNumberFilter";
import { ColumnUtil } from './tablesCols/utils/ColumnUtil';

export const textFilterParamsValues = {filterOptions: ['contains'], maxNumConditions : 1};
const DEFAULT_PAGINATION_SIZE = 25;

/** @ngInject */
export class ReactTableController extends CommonViewController {

    constructor($scope, userService, arsMainDependencies, detailView, tableService, restUrl, title, tableParamsKey,
                rowNodeID, selectedRowsActions, reportOptions, defaultSortModel) {
        super($scope, userService, arsMainDependencies);
        this.$rootScope = userService.fsMainDependencies.$rootScope;
        this.reportIntradayOptions = {options:
                [ REPORT_TYPE.PDF_TRANSACTION_INDIVIDUAL, REPORT_TYPE.PDF_TRANSACTION_INTRADAY,
                    REPORT_TYPE.XLS_TRANSACTION_INTRADAY_REPORT, REPORT_TYPE.CSV_TRANSACTION_INTRADAY_REPORT]};
        delete this.$rootScope.freeText;
        this.sessionPersistance.dataKey = tableParamsKey;
        this.$scope.isSearching = true;
        this.maxAccounts = arsMainDependencies.ArsConfig.MAX_ACCOUNTS;
        this.detailView = detailView;
        this.backendService = tableService;
        this.restUrl = restUrl;
        this.rowNodeID = rowNodeID;
        this.promise = null;
        this.title = title;
        this.isUserReport = true;
        this.refreshAfterReport = false;
        this.tableParamsKey = tableParamsKey;
        this.tableId = this.$scope.tableId;
          // default table exports : csv, xls
        this.supportedExports = [EXPORT_TYPE.CSV, EXPORT_TYPE.XLSX];
        this.getSelectedRowIDs = () => {
            this.selectedNodes = this.gridApi.getSelectedNodes();
            return this.selectedNodes.map(node => node.data[this.rowNodeID]);
        };

        this.defaultSortModel = defaultSortModel;
        this.sessionPersistance.storeColumns = _.debounce(() => {
            const tableParams = this.sessionPersistance.get(this.tableParamsKey) || {};
            // store custom column conf
            tableParams.columns = [...this.gridColumnApi.getColumnState()];
            // update the tableParams with columns definition
            this.sessionPersistance.set(this.tableParamsKey, tableParams);
            if(tableParams.filterModel && Object.keys(this.gridApi.getFilterModel()).length === 0) {
                this.gridApi.setFilterModel(tableParams.filterModel);
            }
        }, 500);

        this.constructFilterFromReactTable = () => {
            if(!this.backendService.service.config.params.filter) {
                this.backendService.service.config.params.filter = {};
            }
            this.colDefs.forEach(col => {
                let key = col.field;
                if (this.reactGridParams.columnMapping && this.reactGridParams.columnMapping[col.field]) {
                    key = this.reactGridParams.columnMapping[col.field];
                }
                // table filter model
                if (this.gridApi.getFilterInstance(col.field)) {
                    const model = this.gridApi.getFilterInstance(col.field).getModel();
                    if(model) {
                        let queryValue = model.filter ? model.filter : model.values;
                        if(queryValue === 'INTRADAY') {
                            this.exportController.reportOptions = this.reportIntradayOptions;
                        } else if (model.filterType === 'number' && model.type !== 'inRange') {
                            queryValue = model.filter;
                        } else if (model.type === 'inRange' || model.filterType === 'date') {
                            if (model.filterType === 'number') {
                                queryValue = {lowerBound: model.filter, upperBound: model.filterTo};
                            } else if (model.filterType === 'date') { // equals date
                                queryValue = {lowerBound: Moment(model.dateFrom).utc(true)};
                                if (model.type === 'inRange') {
                                    queryValue = {lowerBound: Moment(model.dateFrom).utc(true),
                                        upperBound: Moment(model.dateTo).utc(true)};
                                }
                            }
                            // InRange suffix
                            key = key + 'InRange';
                        }
                        this.backendService.service.config.params.filter[key] = queryValue;
                    }
                }
            });
            return this.backendService.service.config.params.filter;
        };

        this.exportController = new ReactExportController(this.$scope, this.getSelectedRowIDs, this.ftsMainDependencies,
            arsMainDependencies, this.supportedExports, reportOptions, () => this.getCamt05xFlag());

        this.fractionDigits = $scope.fractionDigits || 2;

        this.reportServices = new ReportService(this, arsMainDependencies.ArsConfig, userService);

        $scope.$on('export', (event, params) => this.tableExport(params));

        $scope.$on('reportType', (event, params) => this.detectTable(params,true));

        $scope.$on('cancelReportType', (event, params) => this.detectTable(params, false));

        $scope.$on('deleteSelectedItems', (event, params) => this.delete(params.field, params.stateName, params.modalTarget));

        $scope.$on('checkElements', () => this.checkElementsSelected());

        this.dataList = [];

        this.globalActions = [{
            label: this.translate.instant('SAVE_FILTER_COLS_CONF'),
            handleAction: () =>
                ColumnUtil.saveFilter(
                    this.sessionPersistance.get(this.sessionPersistance.dataKey) || {}, this)
        }, {
            label: this.translate.instant('RESET_COLS_CONF'),
            handleAction: () => {
                this.gridApi.paginationSetPageSize(DEFAULT_PAGINATION_SIZE);
                ColumnUtil.resetColumns(
                    this.sessionPersistance.get(this.sessionPersistance.dataKey) || {}, this);
            }
        }];

        // init dateformat refresh case uses $cookies stored dateFormat
        const format = this.ftsMainDependencies.settings ?
            this.ftsMainDependencies.settings.dateTimeFormat : this.cookies.get(DATEFORMAT_KEY);
        const tableParams = this.sessionPersistance.get(tableParamsKey);
        this.defaultReactGridParams = {
            defaultColDef: {
                editable: false,
                sortable: true,
                flex: null,
                minWidth: 100,
                resizable: true,
                floatingFilter: true
            },
            dateTimeFormat: format,
            sideBar: 'columns',
            advancedFilters: true,
            hasExport: false,
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            tooltipShowDelay: 0,
            autoSizeColumns: (!(tableParams && tableParams.columns)),
            enableBrowserTooltips: true,
            watchTableParams: this.watchTableParams,
            getPersistedTableParams: this.getPersistedTableParams,
            lng: this.store.get(keyLanguage),
            startWeekOn: this.ftsMainDependencies.settings ?
                this.ftsMainDependencies.settings.calendarStartingDay : this.cookies.get(CALENDAR_START_DAY_KEY), // 0 | 1 0 = Sunday
            globalActions: () => this.globalActions,
            gridOptions: {
                paginationPageSize: DEFAULT_PAGINATION_SIZE,
                suppressContextMenu: true,
                suppressServerSideInfiniteScroll: false,
                rowModelType: "serverSide",
                onFilterChanged:() => this.filterChanged(),
                getRowId: (params) => {
                    // if leaf level, we have ID
                    if (this.rowNodeID != null) {
                        return params.data[this.rowNodeID];
                    }
                    return "";
                }
            },
            angularScope: this.$rootScope,
            onGridReady: (params) => {
                this.gridApi = params.api;
                this.gridColumnApi = params.columnApi;
                this.applyColumnDefs(tableParams || {});
                this.gridApi.constructTableFilter = this.constructFilterFromReactTable;
                this.gridApi.tableFilter = this.backendService.service.config.params.filter;
                this.gridApi.sort = this.getSort();
                this.$rootScope[this.$scope.tableId] = this.gridApi;
                if (this.$rootScope.tables) {
                    this.$rootScope.tables.push(this.gridApi);
                } else {
                    this.$rootScope.tables = [this.gridApi];
                }
                this.initFilter(tableParams || {});
            },
            onSearchInputChange: (input) => this.handleSearchInputChange(input),
            serializer: arsMainDependencies.serializer,
            errorHandler: this.backendService.service.error,
            requestParams: this.backendService.service.config.params,
            sessionPersistance: this.sessionPersistance,
            onCellClicked: (row) => {
                this.showDetailsView(row.data[this.rowNodeID])
            },
            onExport: (selectedNodes) => {
                this.isExport = true;
                // export ordering
                this.backendService.service.config.params.sort = this.getSort();
                if(this.isAllSelected) {
                    this.processAll(true);
                } else if(this.exportRows(selectedNodes)) {
                    this.backendService.service.config.params['page-index'] = this.gridApi.paginationProxy.currentPage;
                    this.backendService.service.config.params['page-size'] =
                        this.gridApi.gos.paginationPageSize;
                    this.exportController.checkExport();
                }
            },
            supressBuiltInExportDialog: true,
            onReport: (selectedNodes) => {
                this.isExport = false;
                if (this.isAllSelected) {
                    this.processAll(false);
                } else if(this.exportRows(selectedNodes)) {
                    this.isExecuting = true;
                    this.isUserReport ?
                        this.exportController.openReport(this.$rootScope.consolidationCurrency, this.tableFilter,
                            this.isAllSelected, this.total, this.getSort()) : // Acc & val series report
                        this.exportController.openPopup(this.exportController.REPORT_MODAL) // Statements, intradays, transactions.. report;
                }
            },
            onSelectAll: (isAllSelected, gridApi) => {
                this.isAllSelected = isAllSelected;
                this.isOnPageSelected = false;
                gridApi.isAllSelected = isAllSelected;
            },
            onSelectOnPage: (isSelectedOnPage, gridApi) => {
                this.isOnPageSelected = isSelectedOnPage;
                this.isAllSelected = false;
                gridApi.isAllSelected = false;
            }
        };

        userService.promise.then(()=> {
            this.defaultReactGridParams.locale = userService.fsMainDependencies.settings ?
              userService.fsMainDependencies.settings.numberFormatConverted :
              JSON.parse(JSON.stringify(this.cookies.get(NUMBERFORMAT_KEY)));
            if(userService.fsMainDependencies.$rootScope.user.data.clientOnlyImpersonated) {
                delete this.defaultReactGridParams.onExport;
                delete this.defaultReactGridParams.onReport;
            }
        });

        // init consolidationcurr
        this.consolidationCurrency(this.backendService);
    }

    initFilter(tableParams){
        // custom grid filter init by child table
        if(tableParams.columns || tableParams.filterModel) {
            if(tableParams.columns) {
                const filter = {};
                tableParams.columns.filter(col => col.filterModel)
                  .forEach(col => filter[col.columnName] = col.filterModel);
                this.gridApi.setFilterModel(filter);
            } else if(tableParams.filterModel){
                this.gridApi.setFilterModel(tableParams.filterModel);
            }
            this.gridApi.onFilterChanged();
        }
    }

    filterChanged() {
        // date filtering dateTo || range
        if (this.backendService.service.config.params.filter) {

            if (this.$rootScope.pickedDate) {
                this.backendService.service.config.params.dateTo = this.$rootScope.pickedDate;
            } else {
                delete this.backendService.service.config.params.filter.dateTo;
            }
            //input box filtering
            if (this.$rootScope.freeText) {
                this.backendService.service.config.params.filter.freeText = this.$rootScope.freeText;
            } else {
                delete this.backendService.service.config.params.filter.freeText;
            }
        }

        if (this.$rootScope.dateFilter) {
            this.backendService.service.config.params.dateFilter = this.$rootScope.dateFilter;
        } else {
            delete this.backendService.service.config.params.dateFilter;
        }

        // params
        if (this.$rootScope.consolidationCurrency) {
            this.backendService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.$rootScope.consolidationCurrency.code ?
            this.$rootScope.consolidationCurrency.code : this.$rootScope.consolidationCurrency;
        }
        return false;
    }

    processAll(isExport) {
        this.masterRowCount = this.gridApi.paginationProxy.masterRowCount;
        if(!isExport && !this.isUserReport){ // statements, transactions...
            this.constructFilterFromReactTable();
            this.exportController.openPopup(this.exportController.REPORT_MODAL);
        } else {
            this.confirmTotal(this.gridApi.paginationGetRowCount()).then((result) => {
                if(_.isNil(result)) {
                    this.total = this.gridApi.paginationGetRowCount();
                    if (this.exportRows([], this.gridApi.paginationGetRowCount())) {
                        // populate react model filter for backend report/export request
                        this.constructFilterFromReactTable();
                        isExport ?
                            this.exportController.checkExport() :
                            this.exportController.openReport(this.$rootScope.consolidationCurrency, this.tableFilter,
                                this.isAllSelected, this.total, this.getSort());
                    }
                }
            });
        }
    }

    getSort(){
        return this.gridApi.sortController.getSortModel().map(model => `${model.colId},${model.sort}`);
    }

    handleSearchInputChange(input) {
        if (!_.isNil(input) && input !== '') {
            this.$rootScope.freeText = [input];
        } else {
            delete this.$rootScope.freeText;
        }
        this.resetGridSelection();
    }

    exportRows(selectedNodes, elementsCount) {
        this.checkElementsSelected(selectedNodes, elementsCount);
        if (this.$rootScope.checkElements === 0) {
            this.$scope.parentController.infoPop('NO_ROW_SELECTED');
            return false;
        } else if (!this.isExport && this.overLimit) {
            return false;
        }
        this.selectedNodes = this.overLimit ? [] : selectedNodes;
        return this.overLimit ? false : true;
    }

    resetGridSelection() {
        this.isExecuting = false;
        this.gridApi.deselectAll();
        this.gridApi.onFilterChanged();
    }

    checkElementsSelected(selectedNodes, allElements) {
        let elementsCount = selectedNodes ? selectedNodes.length : 0;
        if (this.isAllSelected) {
            elementsCount = allElements;
        }

        if (this.isExport || this.checkMaxAccountsForReport()) {
            this.tableFilter = this.backendService.service.config.params.filter;
            this.$rootScope[this.$scope.tableId] = {
                checkElements: elementsCount, selectAll: this.isAllSelected,
                tableFilter: this.tableFilter, tableCount: this.total, overLimit: this.overLimit
            };
            // elements for top filter export option
            this.$rootScope.checkElements = (this.$rootScope.checkElements || 0) + elementsCount;
        }
    }

    checkMaxAccountsForReport() {// check select all report max individual acc selectio
        if (this.isAllSelected) {
            if (this.total >= this.maxAccounts && (this.restUrl === accounts)) {
                this.infoPop(this.translate.instant('ACCOUNT_REPORT_LIMIT',
                    {rowsLimit: this.maxAccounts, rowsCounter: this.total}));
                this.overLimit = true;
                return false;
            }
        }
        this.overLimit = false;
        return true;
    }

    tableExport(params) {
        this.isExecuting = true;
        // Report only if the 'export' event is received to the correct table or parentTable (if several table groups are opened, several tables will get it)
        if (!params.tableId // value series
            || (params.tableId === this.$scope.tableId // group and/or sub-group
                && (!this.$scope.parentTableId || params.parentTableId === this.$scope.parentTableId))) { // sub-group
            this.isExecuting = true;
            this.reportServices.exportFileForReact(this.filterParams(params), params.reportType.method); // Send params for PDF export
        }
    }

    filterParams(params) {
        if (params == null || params.reportType == null || params.reportType.value == null) return null;
        return params.reportType.value.startsWith('PDF') ? params : null; // Send params for PDF export
    }

    getTableKey() {
        return this.tableParamsKey + '.' + this.$scope.tableId;
    }

    addDefaultFilter(filter) {
        //overwrittes by child //accountstable/statementsTable/transactionsTable
        return filter;
    }

    showDetailsView(id) {
        super.showDetailsView(id, this.detailView);
    }

    showChildDetailsView(id) {
        super.showChildDetailsView(id, this.state.params.id, this.detailView);
    }

    isAnythingSelected() {
        return this.selectedNodes ? this.selectedNodes.length > 0 : false;
    }

    displayElementsForConfirmation() {
        return this.selectedItems || [];
    }

    confirmTotal(total) {
        return super.confirm(new ConfirmationModalBean(this.translate.instant('SELECT_ALL_CONFIRMATION',
            {rowsCounter: total}),"SELECT_ALL", this.modal));
    }

    // Prepare filter for ng-table with selected items from ui-select
    dataFilter(data) {
        this.dataList = [];
        this.$scope.isSearching = true;
        this.backendService.service.config.params.filter = this.addDefaultFilter(FilterUtil.constructFilter(data, this.$scope));
    }

    getCurrentCols() {
        return this.gridApi.columnModel.displayedColumns.map(col => col.colDef);
    }

    initCols() {
        if(this.$scope.hideColumns){
            this.colDefs = this.colDefs.filter(col => !this.$scope.hideColumns.includes(col.field));
        }
	}

    detectTable(params, isExecuting) {
        if (!params.group // no group / sub-group
            || (params.tableId === this.$scope.tableId // group and/or sub-group
                && (!this.$scope.parentTableId || params.parentTableId === this.$scope.parentTableId))) { // sub-group
            if(isExecuting) {
                this.isExecuting = true;
                this.reportServices.exportFileForReact(params, params.reportType.method);
                this.promise.then(() => this.refreshAfterReport ? this.resetGridSelection() : this.isExecuting = false);
            } else {
                this.isExecuting = false;
            }
        }
    }

    delete(selectedNodes, stateName) {
        if(!this.isAllSelected) {
            if(_.isNil(selectedNodes) || selectedNodes.length === 0) {
                this.infoPop(this.translate.instant('SELECT_ELEMENTS'));
                return;
            }
        }
        const nextState = this.state.get(stateName);
        this.state._params = nextState.params;
        this.state.filter = this.constructFilterFromReactTable();
        this.state._params.service = this.backendService;
        if (!this.isAllSelected) {
            this.state._params.ids = this.getSelectedRowIDs();
            this.state._params.names = this.displayElementsForConfirmation();
        } else {
            this.state._params.ids = null;
            this.state._params.names = [this.translate.instant('DELETE_ALL_CONFIRMATION',
                {rowsCounter: this.gridApi.paginationGetRowCount()})];
        }

        this.openModalReact(nextState);
    }

    deleteRow(rowId, display, stateName) {
        const nextState = this.state.get(stateName);
        this.state._params = nextState.params;
        this.state.filter = this.backendService.service.config.params.filter;
        this.state._params.service = this.backendService;
        this.state._params.ids = [rowId];
        this.state._params.names = [display];
        this.open(nextState);
    }

    applyColumnDefs(tableParams){
        if(tableParams.columns) {
            this.gridColumnApi.applyColumnState({ state : tableParams.columns, applyOrder: true });
        }
    }

    getCamt05xFlag() {
        const selectedNodes = this.gridApi.getSelectedNodes();

        if (!selectedNodes.length) { return false; }

        const allCamt052 = selectedNodes.every(node =>
            node.data && (node.data.camt052 === true || (node.data.account && node.data.account.camt052 === true))
        );
        const allCamt053 = selectedNodes.every(node =>
            node.data && (node.data.camt053 === true || (node.data.account && node.data.account.camt053 === true))
        );

        return allCamt052 || allCamt053;
    }
}
